import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup, Table, Dropdown, Image } from "react-bootstrap";
// import MyNavbarInner from "../component/navbarinner";
import Countdown, { zeroPad } from "react-countdown";
import { Link } from "react-router-dom";
import { CircularProgressbar, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import InnerNavbar from "../components/innernav";
import MyFooter from "../components/footer";
import UserChart from "../components/user-chart";
import DailyInvestment from "../components/daily-investment";
import { useSelector } from "react-redux";
import { toastAlert } from "../helper/toastAlert";
import {shortText} from "../helper/custommath"
import moment from "moment";
import config from "../config/config"
import { buyToken, approveToken, getBalanceInfo, validatePurchase, buyCoin } from "./buyContract";
import { tokenValue, numberFloatOnly, formatNumber } from "../helper/custommath";
import { getTxHistory } from "../ApiAction/api"
import SuccessModal from "./successModal"

let initialValue = {
  limit : 10,
  skip : 1
}

export default function Buytoken_page() {
  const [percentage, setPercentage] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const [balanceallowance, setbalanceallowance] = useState({ balance: 0, allowance: 0, coinbalance: 0 })
  const [isload, setisload] = useState(false)
  const [rate, setrate] = useState(0)
  const [bnbrate, setbnbrate] = useState(0)
  const [received, setreceived] = useState(0)
  const [progress, setprogress] = useState({ remaning: 0, soldOutPerc: 0, totalSupply: 0 })

  const [displayrate, setdisplayrate] = useState("")
  const [sendreceive, setsendreceive] = useState({ pay: "", receive: "" })
  const [showallowance, setshowallowance] = useState(false)
  const [loader, setloader] = useState(false)
  const [isBuy, setisBuy] = useState("USDT")
  const [transactionHash, settransactionHash] = useState("")
  const [filter, setFilter] = useState(initialValue)
  const [txData, setTxData] = useState([])
  const [count, setCount] = useState([])
  const walletConnection = useSelector((state) => state.walletConnection);
 
  let {  limit , skip } = filter

  async function getBalance() {
    setisload(true);
    let {
      balanceOf,
      allowance,
      tokenprice,
      coinbalance,
      bnbPrice,
      remaning,
      soldOutPerc,
      totalSupply
    } = await getBalanceInfo();
    setbalanceallowance({ balance: balanceOf, allowance: allowance, coinbalance });
    setrate(tokenprice);
    setisload(false);
    var cal = tokenprice / 1000000;
    cal = 1 / cal;
    setdisplayrate(formatNumber(cal, 5));
    setbnbrate(bnbPrice);
    setprogress({ remaning, soldOutPerc, totalSupply })
  }

  useEffect(() => {
    let timeout;
    if (isAnimating) {
      timeout = setTimeout(() => {
        setPercentage(75);
        setIsAnimating(false);
      }, 500);
    }

    return () => clearTimeout(timeout);
  }, [isAnimating]);

  useEffect(() => {
    getBalance()
  }, [walletConnection.address]);

  async function buy() {
    try {
      let { isError, errMsg } = validatePurchase(sendreceive.pay, balanceallowance, isBuy);
      if (isError) {
        toastAlert("error", errMsg, "bytkn");
        return;
      }
      setloader(true)
      if (isBuy == "USDT") {
        var { txId, status, message, reward } = await buyToken(sendreceive.pay, balanceallowance, isBuy);
      } else if (isBuy == "BNB") {
        var { txId, status, message, reward } = await buyCoin(sendreceive.pay, balanceallowance, isBuy);
      }
      settransactionHash(txId);
      setloader(true);
      setreceived(reward ? reward : sendreceive.receive);
      if (status) {
        toastAlert(
          "success",
          "Your transaction is successfully completed",
          "bytkn"
        );
        window.$("#withdraw_success_modal").modal("show");
        getBalance();
        setsendreceive({ pay: "", receive: "" });
        getTxData()
      } else {
        toastAlert("error", message, "bytkn");
      }
      setloader(false);
    } catch (err) {
      setloader(false);

    }
  }

  const handlechange = async (e) => {
    let value = e.target.value;
    let isNum = numberFloatOnly(value);
    if (isNum) {
      let { swapToken } = tokenValue(rate, value, bnbrate, isBuy);
      setshowallowance(false);
      if (value > balanceallowance.allowance && isBuy == "USDT") {
        setshowallowance(true);
      }
      let Info = { pay: value, receive: swapToken };
      setsendreceive(Info);
    }
  };

  async function approve() {
    setloader(true);
    try {
      let { isError, errMsg } = validatePurchase(sendreceive.pay, balanceallowance, isBuy);
      if (isError) {
        toastAlert("error", errMsg, "bytkn");
        return;
      }
      var { approvalAmt, isAllowed, error } = await approveToken();
      if (isAllowed) {
        if (sendreceive.pay > approvalAmt) {
          toastAlert("error", "Insufficient approval amount", "register");
        } else {
          toastAlert("success", "Successfully approved", "register");
          setshowallowance(false);
        }
      } else {
        toastAlert("error", error, "register");
      }
      setloader(false);
    } catch (err) {

      setloader(false);
    }
  }

  async function getTxData() {
    try {
      let {status, result, totalRecords } = await getTxHistory(filter);
     if(status){
       setTxData(result)
       setCount(totalRecords)
     }else{
      return false
     }
    } catch (err) {
      console.log(err,"errr");
    }
  }

  async function nextClick() {
   setFilter({...filter,...{skip: skip + 1}})
  }

  async function preClick() {
    setFilter({...filter,...{skip: skip - 1}})
  }
  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="timer_panel">
        <div className="timer_head">
          <span className="timer_time">{zeroPad(days)}</span>
          <span className="timer_label">Days</span>
        </div>
        <div className="timer_head">
          <span className="timer_time">{zeroPad(hours)}</span>
          <span className="timer_label">Hours</span>
        </div>
        <div className="timer_head">
          <span className="timer_time">{zeroPad(minutes)}</span>
          <span className="timer_label">Minutes</span>
        </div>
        <div className="timer_head">
          <span className="timer_time">{zeroPad(seconds)}</span>
          <span className="timer_label">Seconds</span>
        </div>
      </div>
    );
  };

  const [selectedOption, setSelectedOption] = useState({
    value: "USDT",
    imageSrc: require("../assets/images/usdt.png"),
  });

  const handleSelect = (eventKey) => {
    const newSelectedOption = options.find(
      (option) => option.value === eventKey
    );
    setSelectedOption(newSelectedOption);
    setisBuy(newSelectedOption?.value)
    setsendreceive({ pay: "", receive: "" });
    setshowallowance(false);
  };

  const options = [
    { value: "USDT", imageSrc: require("../assets/images/usdt.png") },
    { value: "BNB", imageSrc: require("../assets/images/bnb.png") },
  ];


useEffect(() =>{
  getTxData()
},[skip])
console.log(txData,"txDatatxDatatxData");
  return (
    <>
      <InnerNavbar />
      <section className="buy_token_page">
        <Container>

          <Row>
            <Col xxl="12" xl="12" className="mx-auto">
              <div className="dashbox">
                <div className="title_flex">
                  <h3>Buy Token</h3>
                  <h4 className="token_price_box">1 WAIQ Token = {displayrate} USDT</h4>
                </div>
                <Row>
                  <Col xxl="6" xl="6" lg="6" md="6" sm="12" className="mx-auto mb-4">
                    <div className="progress-wrap">
                      <div
                        className="progress"
                        role="progressbar"
                        aria-label="Example with label"
                        aria-valuenow={83}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div className="progress-bar" style={{ width: `${progress.soldOutPerc}%` }} />
                      </div>
                      <p className="progress-title">
                        {" "}
                        Total Tokens = 10M <span>Remaining Tokens = {progress.remaning}</span>
                      </p>
                    </div>
                  </Col>
                </Row>

                <h5 className="text-center mb-3">Presale Ends in</h5>
                <Countdown
                  date={`2025-06-05T20:00:59`}
                  renderer={renderer}
                />
                <form>
                  <div className="Buytoken_input">
                    <div>
                      <div className="d-flex justify-content-between">
                        <Form.Label className="input_join">
                          Enter Amount ({isBuy}) :
                        </Form.Label>
                        {isBuy == "USDT" ? <Form.Label className="input_join">
                          Bal: {formatNumber(balanceallowance?.balance, 6)} USDT
                        </Form.Label> : <Form.Label className="input_join">
                          Bal: {formatNumber(balanceallowance?.coinbalance, 6)} BNB
                        </Form.Label>}
                      </div>
                      <InputGroup className="input_group_box">
                        <Form.Control
                          placeholder="Enter Amount"
                          type="number"
                          value={sendreceive?.pay}
                          disabled={isload}
                          onChange={handlechange}
                        />
                        <Dropdown
                          onSelect={handleSelect}
                          className="image_dropdown_wrapper"
                        >
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="image_dropdown"
                          >
                            <Image
                              src={selectedOption.imageSrc}
                              alt={selectedOption.value}
                              width={32}
                              height={32}
                              className="me-2"
                            />
                            {selectedOption.value}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="image_dropdown_menu">
                            {options.map((option) => (
                              <Dropdown.Item
                                key={option.value}
                                eventKey={option.value}
                              >
                                <Image
                                  src={option.imageSrc}
                                  alt={option.value}
                                  width={32}
                                  height={32}
                                  className="me-2"
                                />{" "}
                                {option.value}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </InputGroup>
                    </div>
                    <div>
                      <Form.Label className="input_join" htmlFor="inputPassword5">
                        You will get :
                      </Form.Label>
                      <InputGroup className="input_group_box">
                        <Form.Control
                          placeholder=""
                          aria-label="Referral Link"
                          aria-describedby="basic-addon1"
                          readOnly
                          value={sendreceive?.receive}
                        />
                        <Dropdown>
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="image_dropdown image_dropdown_notoggle"
                          >
                            <Image
                              src={require("../assets/images/waiq_token.png")}
                              alt="WAIQ"
                              width={32}
                              height={32}
                              className="me-2"
                            />
                            WAIQ
                          </Dropdown.Toggle>
                        </Dropdown>
                      </InputGroup>
                    </div>
                    {!walletConnection.address ? (
                      <Link
                        className="primary_btn mt-3"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Connect Wallet
                      </Link>
                    ) : showallowance ? (
                      <Link
                        to=""
                        className="primary_btn  mt-3"
                        onClick={() => approve()}
                      >
                        Approve{" "}
                        {loader && <i className="fas fa-spinner fa-spin"></i>}
                      </Link>
                    ) : !sendreceive?.pay || sendreceive?.pay == "" || sendreceive?.pay == "0" || sendreceive?.pay == 0 ? (
                      <Link
                        to=""
                        className="primary_btn  mt-3"
                      >
                        Enter Amount{" "}
                      </Link>
                    ) : (
                      <Link
                        to=""
                        className="primary_btn  mt-3"
                        onClick={() => buy()}
                      >
                        Buy{" "}
                        {loader && <i className="fas fa-spinner fa-spin"></i>}
                      </Link>
                    )}

                  </div>
                </form>
              </div>

              <div className="title_flex mb-2 mt-5">
                <h3>History</h3>
              </div>               
              <Table responsive className="referral_table">
                <thead>
                  <tr>
                   <th>No.</th>
                    <th>Date & Time</th>
                    <th>Symbol</th>
                    <th>Amount</th>
                    <th>Receive</th>
                    <th>Address</th>
                    <th>TxHash</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                <tbody>
                { txData && txData.length > 0 && txData.map((value,i) =>{
                return( 
                  <tr>
                    <td>{i+1}</td>
                    <td>{moment(value?.createdAt).format("DD-MM-YYYY hh:mm")}</td>
                    <td>{value?.symbol}</td>
                    <td>{value?.pay}</td>
                    <td>{value?.receive}</td>
                    <td>{shortText(value?.address)}</td>
                    <td><a href={`${config?.txLink}tx/${value?.txId}`} target="blank">{shortText(value?.txId)}</a></td>
                    {/* <td className="text_green">Completed</td> */}
                  </tr>
                  )
                })}
                </tbody>
              </Table>
              <div class="d-flex justify-content-end">
              {skip > 1 &&
               <Button className="primary_btn  mt-3 me-2" onClick = {preClick}>Pre</Button>
                }
               {count > skip * limit &&
                <Button className="primary_btn  mt-3" onClick = {nextClick}>Next</Button>
               }
              </div>
              <SuccessModal
                transactionHash={transactionHash}
                settransactionHash={settransactionHash}
                received={received}
                setreceived={setreceived}
              />
            </Col>
          </Row>
        </Container>
      </section>
      <MyFooter />
    </>
  );
}
